// src/services/api.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.jmkinfosoft.com';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log(`📤 ${config.method.toUpperCase()} ${config.baseURL}${config.url}`);
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for handling errors
api.interceptors.response.use(
  (response) => {
    console.log(`📥 ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error(`❌ API Error:`, error.response?.status, error.response?.data);
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userName');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userMobile');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authApi = {
  requestOtp: (data) => api.post('/api/auth/otp/request', data),
  verifyOtp: (data) => api.post('/api/auth/otp/verify', data),
  adminLogin: (data) => api.post('/api/auth/admin/login', data),
  candidateLogin: (data) => api.post('/api/auth/login', data),
  getMe: () => api.get('/api/auth/me'),
};

// Requirement APIs
export const requirementApi = {
  list: (params) => api.get('/api/requirements', { params }),
  get: (id) => api.get(`/api/requirements/${id}`),
  create: (data) => api.post('/api/requirements', data),
  update: (id, data) => api.put(`/api/requirements/${id}`, data),
  uploadJd: (id, file) => {
    const formData = new FormData();
    formData.append('jd_file', file);
    return api.post(`/api/requirements/${id}/jd-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  delete: (id) => api.delete(`/api/requirements/${id}`),
};

// Application APIs
export const applicationApi = {
  list: (params) => api.get('/api/applications', { params }),
  get: (id) => api.get(`/api/applications/${id}`),
  create: (data) => api.post('/api/applications', data),
  uploadFile: (applicationId, fieldId, formData) => 
    api.post(`/api/applications/${applicationId}/answers/${fieldId}/file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  updateStatus: (id, data) => api.patch(`/api/applications/${id}/status`, data),
};

// Candidate APIs
export const candidateApi = {
  getProfile: () => api.get('/api/candidates/me'),
  updateProfile: (data) => api.put('/api/candidates/me', data),
  uploadResume: (file) => {
    const formData = new FormData();
    formData.append('resume', file);
    return api.post('/api/candidates/me/resume', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

// User APIs (admin only)
export const userApi = {
  list: (params) => api.get('/api/users', { params }),
  create: (data) => api.post('/api/users', data),
  toggleActive: (id, isActive) => api.patch(`/api/users/${id}/active`, { is_active: isActive }),
};

// Communication APIs
export const communicationApi = {
  send: (data) => api.post('/api/communications/send', data),
  list: (params) => api.get('/api/communications', { params }),
};

export default api;